import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { currentUrlLang, rememberChosenLanguage, switchTarget } from '@/i18n/urlLanguage';

export default function LanguageSwitcher({ variant = 'default' }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  // Langue réellement affichée, ramenée à "fr" ou "en"
  const currentLang = (i18n.resolvedLanguage || i18n.language || 'fr').startsWith('en') ? 'en' : 'fr';

  const toggleLanguage = () => {
    const newLang = currentLang === 'fr' ? 'en' : 'fr';
    // The choice is saved (ridalo_lang), then the same page opens in the
    // other language's URL (/en/… ↔ /…). French private pages (dashboard,
    // sign-in…) have one URL: the language changes in place.
    rememberChosenLanguage(newLang);
    const target = switchTarget(newLang, location, currentUrlLang());
    if (target) window.location.assign(target);
    else i18n.changeLanguage(newLang);
  };

  // Variante mobile : bouton pleine largeur plus visible
  if (variant === 'mobile') {
    return (
      <button
        onClick={toggleLanguage}
        data-testid="language-switcher-mobile"
        className="w-full flex items-center justify-between px-4 py-3 text-base font-medium text-primary hover:bg-slate-50 rounded-lg border border-slate-200 transition-colors"
        aria-label={currentLang === 'fr' ? 'Passer en anglais' : 'Switch to French'}
      >
        <span className="flex items-center gap-2">
          {currentLang === 'fr' ? '🇫🇷 Français' : '🇬🇧 English'}
        </span>
        <span className="text-sm text-slate-500">
          {currentLang === 'fr' ? 'EN' : 'FR'}
        </span>
      </button>
    );
  }

  // Variante desktop : bouton compact dans le header
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      data-testid="language-switcher"
      className="flex items-center gap-1 px-3"
      aria-label={currentLang === 'fr' ? 'Passer en anglais' : 'Switch to French'}
    >
      {currentLang === 'fr' ? (
        <>🇫🇷 FR</>
      ) : (
        <>🇬🇧 EN</>
      )}
    </Button>
  );
}
